import { Box, Paper, Table } from "@mantine/core";
import { useSelector } from "react-redux";
import { IAuth } from "../../interfaces/IAuth";
import { IGeneral } from "../../interfaces/IGeneral";
import util from "../../styles/util.module.css";

export function Test() {
  const { user } = useSelector((state: { auth: IAuth }) => state.auth);
  const { permissions } = useSelector((state: { general: IGeneral }) => state.general);

  const rows = user?.permissions?.map((element, index) => (
    <Table.Tr key={index}>
      <Table.Td>{element.module}</Table.Td>
      <Table.Td>{permissions.find((f: any) => f.code === element?.code)?.name}</Table.Td>
      <Table.Td>{element.menu}</Table.Td>
      <Table.Td>{element.portal}</Table.Td>
      <Table.Td>{element.code}</Table.Td>
    </Table.Tr>
  ));

  return (
    <Paper p="lg" classNames={{ root: util.scrollAuto }}>
      <Box w="max-content">
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>module</Table.Th>
              <Table.Th>menu.name</Table.Th>
              <Table.Th>menu.code</Table.Th>
              <Table.Th>portal</Table.Th>
              <Table.Th>code</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>{rows}</Table.Tbody>
        </Table>
      </Box>
    </Paper>
  );
}
